import gql from 'graphql-tag';

export const getS3DownloadPreSignedUrl = gql `
    query getS3DownloadPreSignedUrl( 
    $programType: String,
    $s3Key: String ) {
        getS3DownloadPreSignedUrl( 
        programType: $programType,
        s3Key: $s3Key ){
            responseCode
            s3PresignedUrl
        }
    }`;
